import { Tooltip } from 'bootstrap';
const global_func = require('./globals.js');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

var min_load = 500;
var ajaxTime = 0;
var wait = 0;
var totalTime = 0;
var tooltipTriggerList;
var tooltipList;

jQuery(document).ready(function($) {
  $('.ajax-form').on('submit', function(event, stealth_mode){
      event.preventDefault();
      wait = 0;
      ajaxTime = new Date().getTime();

      var results_el = $(this).attr('data-results');
      var results_el_2 = $(this).attr('data-results-2');

      if(stealth_mode!=true) {
        $(results_el).html($('.ajax-loader-hold .ajax-loader').clone());

        if(results_el_2) {
          $(results_el_2).html($('.ajax-loader-hold .ajax-loader').clone());
        }
      }

      var url = $(this).attr('action');
      var method = $(this).attr('method');
      var data = $(this).serialize();
      var form = $(this);
      $.ajax({
          url: url,
          method: method,
          data: data,
          dataType: 'JSON',
          cache: false,
          processData: false,
          success:function(response)
          {
            totalTime = new Date().getTime()-ajaxTime;
            if(response.forceRefresh == 'true') {
              window.location = window.location.href;
            }
            if(response.message) {
              alert(response.message);
            }
            if(response.response_html) {
              if(totalTime < min_load) {
                wait = min_load-totalTime;
              }
              
              setTimeout(function() {
                $(results_el).html(response.response_html);
                if(response.diary_links) {
                  $('.date-links').html(response.diary_links);
                }
                if(response.booking_list_html) {
                  $('.booking-list-hold').html(response.booking_list_html);
                }
                if(response.cancelled_list_html) {
                  $('.cancelled-list-hold').html(response.cancelled_list_html);
                }
                if(response.booking_count_html) {
                  $('.booking-count-hold').html(response.booking_count_html);
                }
                if(response.date_prev) {
                  $('.diary-back').attr('data-date', response.date_prev);
                }
                if(response.date_next) {
                  $('.diary-forward').attr('data-date', response.date_next);
                }
                if(response.fitler_html) {
                  $('.booking-filter-hold').html(response.fitler_html);
                }
                if($(form).hasClass('get-diary-form')) {
                  $(form).trigger('diary-loaded');
                  $('.filter-list').hide();
                  tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                  tooltipList = [tooltipTriggerList].map(tooltipTriggerEl => Tooltip.getOrCreateInstance(document.body, {selector: '[data-bs-toggle="tooltip"]'}));
                }
              }, wait);
            }
          },
          error: function(response) {
          }
      });
  });

  tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipList = [tooltipTriggerList].map(tooltipTriggerEl => Tooltip.getOrCreateInstance(document.body, {selector: '[data-bs-toggle="tooltip"]'}));

  var urlParams = new URLSearchParams(window.location.search);
  var dateParam = urlParams.get('date');

  if($('.get-diary-form').length) {
    if (window.history.replaceState) {
      window.history.replaceState({}, null, window.location.pathname + '?date=' + $('.get-diary-form').find('input[name="date"]').val());
    }
  }

  $(window).on('popstate', function(e) {
    urlParams = new URLSearchParams(window.location.search);
    dateParam = urlParams.get('date');
    if($('.get-diary-form').length) {
      $('.get-diary-form').find('input[name="date"]').val(dateParam)
      $('.get-diary-form').trigger('submit');
    }
  });

  $('.change-location-form').on('change', 'select', function(event) {
    event.preventDefault();
    $(this).trigger('submit');
  });

  if($('a.location-change-link').length) {
    $('body').on('click', 'a.location-change-link', function(event) {
      event.preventDefault();
      $('.change-location-form select').slideToggle();
    });
  }
  

  $('.get-diary-form').on('change', 'input', function(event) {
    global_func.change_diary_date($('.get-diary-form'));
  });

  $('.get-diary-form').trigger('submit');
});

var ajaxTime;

$( document ).ajaxStart(function() {
  ajaxTime = new Date().getTime();
  $( ".ajax-loader" ).addClass('show');
});

$( document ).ajaxStop(function() {
  var totalTime = new Date().getTime()-ajaxTime;
  var wait = 0;
  var min_load = 500;
  if(totalTime < min_load) {
    wait = min_load-totalTime;
  }
  setTimeout(function() {
    $( ".ajax-loader" ).removeClass('show');
  }, wait);
});